import React from 'react'
import HeroSection from '../element/homeComp/HeroSection';
import ExchangeSection from '../element/homeComp/ExchangeSection';
import AboutSection from '../element/homeComp/AboutSection';
import ToolSection from '../element/homeComp/ToolSection';
import CompanySection from '../element/homeComp/CompanySection';
import FeatureSection from '../element/homeComp/FeatureSection';
import AccountSection from '../element/homeComp/AccountSection';
import TestmonialSection from '../element/homeComp/TestmonialSection';
import AppSection from '../element/homeComp/AppSection';
import BlogSection from '../element/homeComp/BlogSection';

const Home = () => {
  return (
    <div>
      <HeroSection/>
      <ExchangeSection/>
      <AboutSection/>
      <ToolSection/>
      <CompanySection/>
      <FeatureSection/>
      <AccountSection/>
      <TestmonialSection/>
      <AppSection/>
      <BlogSection/>
    </div>
  )
}

export default Home